import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { defaultListPaginationParameters } from '../../../data-access';
import { AuditableLookupsComponent } from '../../../lookups';
import { ActionConfigFactory, ActionTypeEnum, ActionTypeHandlerEnum, IActionConfig } from '../../../ui';
import { GeographicalZonesApiClientProvider, IGeographicalZonesApiClient } from '../clients';
import { IGeographicalZoneResponse } from '../dtos';
import { CreateUpdateGeographicalZoneComponent } from '../../../../../trash/location-management';
import { LocationManagementPermissions } from '../../common/permissions';

@Component({
  selector: 'app-geographical-zones',
  standalone: true,
  providers: [],
  imports: [CommonModule, AuditableLookupsComponent],
  templateUrl: './geographical-zones.component.html',
  styleUrls: ['./geographical-zones.component.scss']
})
export class GeographicalZonesComponent {
  client: IGeographicalZonesApiClient = inject(GeographicalZonesApiClientProvider).getClient();
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  router = inject(Router);
  defualtPaginationParameters = defaultListPaginationParameters;

  supportedActions: IActionConfig<IGeographicalZoneResponse>[] = [
    ActionConfigFactory.createDialog(this.dialogService, {
      type: ActionTypeEnum.VIEW,
      componentType: CreateUpdateGeographicalZoneComponent,
      headerResolver: (x) => `${this.translate.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE')} '${x!.englishName}'`,
      permission: LocationManagementPermissions.GeographicalZones.Read
    }),
    {
      type: ActionTypeEnum.CREATE,
      label: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.NEW_GEOGRAPHICAL_ZONE')}`,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateGeographicalZoneComponent,
        configResolver: (item?: IGeographicalZoneResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE')}`
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.GeographicalZones.Create
    },
    {
      type: ActionTypeEnum.UPDATE,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateGeographicalZoneComponent,
        configResolver: (item?: IGeographicalZoneResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE')} '${item!.englishName}'`
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.GeographicalZones.Update
    }
  ];
}
